import { useContext, createContext } from 'react';

import { ErrorContextProps } from '../types';

// ------------------------------------------------

export const ErrorContext = createContext<ErrorContextProps | null>(null);

export const useErrorContext = () => {
  const context = useContext(ErrorContext);

  if (!context) throw new Error('useErrorContext must be use inside ErrorProvider');

  return context;
};
